import { PostUserMapperParameter, PostUserFactory } from "@/v2/models/post-users.js";
import mapperMixin from "@/v2/mixins/mapper.js";
import httpMixin from "@/v2/mixins/http.js";

export default {
    mixins: [mapperMixin, httpMixin],
    data() {
        return {
            postUsersUrl: window.bo.postUsersUrl,
        };
    },
    methods: {
        _postUserMapper(postUser) {
            return {
                id: postUser.id,
                post_id: postUser.post_id,
                user_id: postUser.user_id,
                created_at: postUser.created_at,
                updated_at: postUser.updated_at,
            };
        },

        parsePostUser(postUser) {
            return PostUserFactory.construct(this.createMapperParameter(new PostUserMapperParameter()), postUser)
        },

        parsePostUsers(postUsers) {
            let parsedPostUsers = [];

            postUsers.forEach((postUserData) => {
                const postUser = this.parsePostUser(postUserData);
                parsedPostUsers.push(postUser);
            });

            return parsedPostUsers;
        },

        getPostUser(id, payload, success, failure) {
            return this.getData(
                this.postUsersUrl + "/" + id,
                payload,
                (response) => {
                    success(this.parsePostUser(response.data));
                },
                failure
            );
        },

        getPostUsers(payload, success, failure) {
            return this.getData(
                this.postUsersUrl,
                payload,
                (response) => {
                    success(this.parsePostUsers(response.data.data));
                },
                failure
            );
        },

        createPostUser(payload, success, failure) {
            return this.postData(
                this.postUsersUrl,
                payload,
                (response) => {
                    success(this.parsePostUser(response.data));
                },
                failure
            );
        },
        createPostUsers(payload, success, failure) {
            return this.postData(
                this.postUsersUrl,
                payload,
                () => {
                    success();
                },
                failure
            );
        },
    },
};
